import React from 'react';
import { KTSVG } from '../../../../_metronic/helpers';
import { JobStatus } from '../../job-summary/Interfaces';
import { StatusFilter } from '../utils/customerListTypes';

export const ALL_JOB_STATUSES: JobStatus[] = [
  'Active',
  'Open',
  'Pending',
  'Awaiting Client Response',
  'Overdue',
  'Closed',
  'Cancelled',
  'Archived',
];

export interface StatusFilterDropdownProps {
  statusFilter: StatusFilter;
  onStatusFilterChange: (value: StatusFilter) => void;
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
}

const StatusFilterDropdown: React.FC<StatusFilterDropdownProps> = ({
  statusFilter,
  onStatusFilterChange,
  open,
  onToggle,
  onClose,
}) => {
  return (
    <div className="position-relative">
      <button
        className="form-control form-control-solid text-start d-flex justify-content-between align-items-center"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        style={{ cursor: 'pointer' }}
      >
        <span>
          {statusFilter.length === 0 ? 'No statuses selected' : 
           statusFilter.length === 1 ? `${statusFilter[0]} Jobs` :
           `${statusFilter.length} statuses selected`}
        </span>
        <KTSVG path="/media/icons/duotune/arrows/arr072.svg" className="svg-icon-5" />
      </button>
      
      {open && (
        <div className="dropdown-menu show position-absolute w-100" style={{ 
          top: '100%', 
          left: '0', 
          zIndex: 9999
        }}>
          {ALL_JOB_STATUSES.map(status => (
            <button
              key={status}
              className="dropdown-item d-flex align-items-center"
              onClick={(e) => {
                e.stopPropagation();
                const newFilter = statusFilter.includes(status) 
                  ? statusFilter.filter(s => s !== status)
                  : [...statusFilter, status];
                onStatusFilterChange(newFilter);
              }}
            >
              <input
                type="checkbox"
                className="form-check-input me-2"
                checked={statusFilter.includes(status)}
                readOnly
              />
              {status}
            </button>
          ))}
          <div className="dropdown-divider"></div>
          <button
            className="dropdown-item text-primary"
            onClick={(e) => {
              e.stopPropagation();
              onStatusFilterChange(ALL_JOB_STATUSES);
              onClose();
            }}
          >
            Select All
          </button>
          <button
            className="dropdown-item text-danger"
            onClick={(e) => {
              e.stopPropagation();
              onStatusFilterChange([]);
              onClose();
            }}
          >
            Clear All
          </button>
        </div>
      )}
    </div>
  );
};

export default StatusFilterDropdown;
